<template>
	<div class="Login1">
		<div class="login-background-image">
			<div class="login-card">
				<div class="card-background">
					<h1 class="login-header">
						Login
					</h1>
					<div class="input-section">
						<label>Username</label>
						<input
							id="username"
							type="text"
							placeholder="Username"
							autocomplete="off"
						/>
					</div>
					<div class="input-section">
						<label>Password</label>
						<input id="password" type="password" placeholder="Password" />
					</div>
					<button class="login-btn bg-amplitude">
						Login
					</button>
					<h2>Forgot Password ?</h2>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Login1",
	mixins: [],
	props: [],
	data() {
		return {};
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
@import url("./Login1.scss");
</style>
